import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31f42986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-details-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left back-button" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "feedback-wrapper" }
const _hoisted_5 = { class: "feedback-details-header" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "feedback-form-container" }
const _hoisted_8 = { class: "feedback-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back-button-container",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onNavigateBack')))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "title", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "form", {}, undefined, true),
          _createVNode(_component_FbxButton, {
            "button-text": "Submit",
            theme: "primary",
            class: "portrait-text-color",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSubmit'))),
            disabled: _ctx.isSubmitDisabled
          }, null, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}